@if (env.urlDatastudioCompro && env.urlDatastudioAttestation && isAdmin() && type!='security-policies') {
<div>
  <ul ngbNav #nav="ngbNav" class="nav-tabs">
    @if (type == 'compromise-reports' || type == 'attestations') {
    @for (tab of getTabs(type); track tab.id) {
    <li ngbNavItem>
      <a ngbNavLink class="d-flex flex-row justify-content-center align-items">
        @if (tab.img) {
        <img [id]="tab.imgId" [src]="tab.img">
        }
        <p>{{tab.label | translate}}</p>
      </a>
      <ng-template ngbNavContent>
        @switch (tab.content) {
        @case ('compromise-reports') {
        <app-liste-compromise-reports></app-liste-compromise-reports>
        }
        @case ('attestations') {
        <app-liste-attestations></app-liste-attestations>
        }
        @case ('browser-attestations') {
        <app-list-browser-attestations></app-list-browser-attestations>
        }
        @case ('statistics') {
        <app-statistics [type]="type"></app-statistics>
        }
        }
      </ng-template>
    </li>
    }
    }
    @if (type == 'setting') {
    <li ngbNavItem="settings">
      <a ngbNavLink class="d-flex flex-row justify-content-center">
        <img id="settings" src="assets/icons/ui.svg">
        <p>{{ 'menu-settings' | translate }}</p>
      </a>
      <ng-template ngbNavContent>
        <app-settings></app-settings>
      </ng-template>
    </li>
    <li ngbNavItem="ref-policies">
      <a ngbNavLink class="d-flex flex-row justify-content-center">
        <img id="ref-policies" src="assets/icons/Settings/tag.svg" alt="Reference Policies">
        <p>{{ 'ref-policies' | translate }}</p>
      </a>
      <ng-template ngbNavContent>
        <app-ref-policies></app-ref-policies>
      </ng-template>
    </li>
    <li ngbNavItem="clients">
      <a ngbNavLink class="d-flex flex-row justify-content-center">
        <img id="clients" src="assets/icons/person.dark.svg">
        <p>{{ ('setting-nav-clients') | translate }}</p>
      </a>
      <ng-template ngbNavContent>
        <app-clients-settings></app-clients-settings>
      </ng-template>
    </li>
    }
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>
}
@else {
@if (type == 'compromise-reports') {
<div class="app-list">
  <app-liste-compromise-reports></app-liste-compromise-reports>
</div>
}
@if (type == 'attestations') {
@if(hasBothAttestationsRoles()){
<ng-container>
  <ul ngbNav #navAttest="ngbNav" class="nav-tabs">
    <li ngbNavItem>
      <a ngbNavLink class="d-flex flex-row justify-content-center align-items">
        <img id="bw" src="assets/icons/probesFamilies/black&White.png">
        <p>{{'attestations-nav-report-list' | translate}}</p>
      </a>
      <ng-template ngbNavContent>
        <app-liste-attestations></app-liste-attestations>
      </ng-template>
    </li>
    <li ngbNavItem>
      <a ngbNavLink class="d-flex flex-row justify-content-center">
        <img id="wp" src="assets/icons/BrowserAttestations/logoWP.png">
        <p>{{'browser-attestations-nav-statistics' | translate}}</p>
      </a>
      <ng-template ngbNavContent>
        <app-list-browser-attestations></app-list-browser-attestations>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="navAttest"></div>
</ng-container>
}@else {
<ng-container *kaHasRoles="['bo-dip-attestations-viewer']; checkRealm: true">
  <div class="app-list">
    <app-liste-attestations></app-liste-attestations>
  </div>
</ng-container>
<ng-container *kaHasRoles="['bo-dip-browser-attestations-viewer']; checkRealm: true">
  <div class="app-list">
    <app-list-browser-attestations></app-list-browser-attestations>
  </div>
</ng-container>
}
}
}

@if (type == 'security-policies') {
<div>
  <ul ngbNav #nav="ngbNav" class="nav-tabs">
    @for (tab of getSecurityTabs(); track tab.id) {
    <li [ngbNavItem]="tab.id">
      <a ngbNavLink class="d-flex flex-row justify-content-center">
        <img [id]="tab.imgId" [src]="tab.img">
        <p>{{tab.label | translate}}</p>
      </a>
      <ng-template ngbNavContent>
        @switch (tab.content) {
        @case ('active') {
        <app-active-policies (changeTab)="nav.select($event)"></app-active-policies>
        }
        @case ('simulation') {
        <app-simulation></app-simulation>
        }
        }
      </ng-template>
    </li>
    }
  </ul>
  <div [ngbNavOutlet]="nav"></div>
  <app-toast-component></app-toast-component>
</div>
}